import axios from "axios";
export const BASE_URL = "https://backend.dahiyainsurance.com";

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});
